import Container from "@components/layout/Container";
import {yearsOfExperience} from "@/utils/companyInfo";

const stats = [
	{num: `${yearsOfExperience}+`, label: "Років досвіду"},
	{num: "3200+", label: "Виконаних робіт"},
	{num: "98%", label: "Задоволених клієнтів"},
	{num: "10", label: "Років гарантії"},
];

export default function StatsBar() {
	return (
		<section className="stats">
			<Container>
				<div className="stats-grid">
					{stats.map((s) => (
						<div key={s.label}>
							<div className="stat-num">{s.num}</div>
							<div className="stat-label">{s.label}</div>
						</div>
					))}
				</div>
			</Container>
		</section>
	);
}
